import {useDispatch, useSelector} from 'react-redux'
import {RouteComponentProps} from 'react-router-dom'
import SingleUser from 'src/components/SingleUser'
import User from 'src/models/User'
import {RootState} from 'src/redux/rootReducer'
import {actions as UserActions} from 'src/redux/modules/users'
import {useState} from 'react'
import {useEffect} from 'react'

export type UserCreateProps = RouteComponentProps & {}

const UserCreate: React.FC<UserCreateProps> = ({history}: UserCreateProps) => {
  const [isSaving, setIsSaving] = useState<Boolean>(false)
  const [isSuccess, setIsSuccess] = useState<boolean>(false)
  const {dataState} = useSelector((state: RootState) => state.users)

  const dispatch = useDispatch()

  const onSaveUser = (updatedUser: User) => {
    // Save the user.
    dispatch(UserActions.saveUser({user: updatedUser}))

    // Set the flag
    setIsSaving(true)
  }

  const onCancelUser = () => {
    // Back to the users page.
    history.goBack()
  }

  useEffect(() => {
    if (isSaving && dataState.state !== 'loading') {
      // Finished saving.
      setIsSaving(false)

      if (!dataState.error) {
        // And no error!
        setIsSuccess(true)
      }
    }
  }, [isSaving, dataState, history])

  return (
    <SingleUser
      onSaveUser={onSaveUser}
      onCancel={onCancelUser}
      onDismissSuccess={() => history.goBack()}
      title="Create New User"
      isBusy={dataState.state === 'loading'}
      isSuccess={isSuccess}
      errorMessage={dataState.error?.message}
    />
  )
}

export default UserCreate
